import api from './api';

export const getPublicPlans = () =>
  api.get('/public/plans').then(r => r.data);

export const registerAccount = (data) =>
  api.post('/public/register', data).then(r => r.data);

export const verifyEmail = (token, email) =>
  api.post('/public/verify-email', { token, email }).then(r => r.data);
